import { render, staticRenderFns } from "./filedetail-add-batch.vue?vue&type=template&id=73cdbaae&scoped=true&"
import script from "./filedetail-add-batch.vue?vue&type=script&lang=js&"
export * from "./filedetail-add-batch.vue?vue&type=script&lang=js&"
import style0 from "./filedetail-add-batch.vue?vue&type=style&index=0&id=73cdbaae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cdbaae",
  null
  
)

export default component.exports